import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { CookieService } from 'ngx-cookie-service'

import { MenuService } from 'app/services/menu.service'

@Component({
  selector: 'app-matching-tool',
  templateUrl: './matching-tool.component.html',
  styleUrls: ['./matching-tool.component.scss']
})
export class MatchingToolComponent implements OnInit {
  url

  constructor(
    private http: HttpClient,
    private menuService: MenuService,
    private cookies: CookieService,
  ) { }

  ngOnInit() {
    this.url = this.menuService.getScreen('MatchingTool').url+this.cookies.get('at') + '&mode='+(localStorage.getItem('theme') == 'grey' ? 'light' : 'dark')
  }
}
